import { LOCALES } from '@marketplace/i18n';

export const landingPageBanner = {
  [LOCALES.ENG]: {
    developer_landing_banner_title: 'Bring your ideas to life',
    developer_landing_banner_description:
      'The Greenway Health Developer Platform makes it easy to build, deploy, and connect the applications you build with Greenway Health products like Intergy and Prime Suite.',
    developer_landing_banner_button: 'Start Now!',
  },
};
